import { useContext } from "react";
import { NotifcationContext, NotificationContextProps } from "./NotificationProvider";

export function useNotification(): NotificationContextProps {
  const { notification, addNotification, removeNotification } = useContext(NotifcationContext);
  return { notification, addNotification, removeNotification };
}
